module.exports = __webpack_public_path__ + "static/media/sl.ddbd1d9b.svg";